import { Banner, Col, Button, Row } from 'darrius';

interface IRequestCallToActionProps {
  content: {
    description: string;
    buttonRequest: string;
  };
  title: string;
  slug?: string;
}

export const RequestCallToAction = (props: IRequestCallToActionProps) => {
  const { content, title, slug } = props;

  const requestCall = () => {
    window.tagManager.custom({
      event: 'selfDescribingEvent',
      schema: 'iglu:br.com.getninjas/web_pro_sign_up/jsonschema/1-0-1',
      data: {
        step: 'request_redirect',
        action: 'click',
        state: `www.getninjas.com.br/${slug}`,
        label: slug,
      },
    });
  };

  return (
    <Banner
      as="section"
      className="full"
      size="2"
      title={title}
      text={content.description}
    >
      <Row className="space-top center-sm">
        <Col className="col-sm-12 col-md-5">
          <Button.Link
            href={`/${slug}`}
            onClick={requestCall}
            className="button secondary full-width"
          >
            {content.buttonRequest}
          </Button.Link>
        </Col>
      </Row>
    </Banner>
  );
};

export default RequestCallToAction;
